import React from "react";
import { Icon, Icomoon } from "../../brand";

export enum StarState {
  empty,
  half,
  full
}

export interface IStar {
  state?: StarState;
}

export const Star: React.FC<IStar> = ({ state }) => {
  let icon: Icomoon = Icomoon.starEmpty;
  switch (state) {
    case StarState.half:
      icon = Icomoon.starHalf;
      break;
    case StarState.full:
      icon = Icomoon.starFull;
      break;
  }

  return (
    <Icon className="star" icomoon={icon} />
  );
};

Star.defaultProps = {
  state: StarState.empty,
};

Star.displayName = "Star";
